var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.params.colDef.CellRendererParams.openSideBar(_vm.params.data)}}},[_vm._v("\n      "+_vm._s(_vm.params.data.invoice_id)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }